import React from 'react';

/**
 * Componente que muestra el resumen de configuración
 */
const ResumenConfiguracion = ({ 
  formData, 
  onEdit,
  readOnly = false
}) => {
  const pesoCalificacionValue = Number(formData.pesoCalificacion);
  const mostrarPesoCalificacion = Number.isFinite(pesoCalificacionValue) && pesoCalificacionValue > 0;

  const cantidadTarjetasVisibles = 1 + (mostrarPesoCalificacion ? 1 : 0);
  const colClass = cantidadTarjetasVisibles === 1 ? 'col-md-12' : cantidadTarjetasVisibles === 2 ? 'col-md-6' : 'col-md-4';

  return (
    <div className="card mb-4">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h6 className="mb-0">
          <i className="fas fa-cogs me-2 text-info"></i>
          Configuración
        </h6>
        {!readOnly && (
          <button 
            type="button" 
            className="step4-btn-edit"
            onClick={() => onEdit(2)}
          >
            <i className="fas fa-edit me-1"></i>
            Editar
          </button>
        )}
      </div>
      <div className="card-body">
        <div className="row">
          <div className={colClass}>
            <div className="text-center p-3 border rounded">
              <h4 className="text-primary mb-1">{formData.tiempoLimite}</h4>
              <small className="text-muted">Minutos</small>
              <p className="mb-0"><strong>Tiempo Límite</strong></p>
            </div>
          </div>
          {mostrarPesoCalificacion && (
            <div className={colClass}>
              <div className="text-center p-3 border rounded">
                <h4 className="text-warning mb-1">{formData.pesoCalificacion}</h4>
                <small className="text-muted">Factor</small>
                <p className="mb-0"><strong>Peso Calificación</strong></p>
              </div>
            </div>
          )}
        </div>
        
        <div className="row mt-3">
          <div className="col-md-6">
            <div className="d-flex align-items-center">
              <i className={`fas ${formData.estadoActivo ? 'fa-toggle-on text-success' : 'fa-toggle-off text-muted'} me-2`}></i>
              <span style={{ color: '#0063a1', fontWeight: '600' }}>Estado: </span>
              <span className={`ms-1 ${formData.estadoActivo ? 'text-success' : 'text-muted'}`}>
                {formData.estadoActivo ? 'Activa' : 'Inactiva'}
              </span>
            </div>
          </div>
        </div>
        
        <div className="mt-3">
          <div style={{ color: '#0063a1', fontWeight: '600', marginBottom: '8px' }}>
            Instrucciones:
          </div>
          <p className="mb-0" style={{whiteSpace: 'pre-wrap'}}>
            {formData.instrucciones || <em className="text-muted">No especificadas</em>}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ResumenConfiguracion;
